import { alertConstants } from '../constants';

const initialState = {
    open: false,
    message: "",
}

export function alert(state = initialState, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: 'alert-success',
        message: action.message
      };
    case alertConstants.ERROR:
      return {
        ...state,
        type: 'alert-danger',
        open: true,
        message: action.message
      };
    case alertConstants.CLEAR:
      return {
        ...state,
        open: false
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alert.reducer.js